<template>
<!--	<transition enter-active-class="animated slideInDown faster">-->
<!--		-->
<!--	</transition>-->
	<section>
		<Announcements />
		<nav class="navbar navbar-expand-lg bg-white-always">
			<div class="container-fluid">
				<div class="navbar-wrapper">
					<div class="navbar-minimize">
						<button v-if="!inCollaborator" id="minimizeSidebar" class="btn btn-icon btn-round" @click="changeSidebarType">
							<i class="nc-icon nc-minimal-right text-center visible-on-sidebar-mini"></i>
							<i class="nc-icon nc-minimal-left text-center visible-on-sidebar-regular"></i>
						</button>
					</div>
					<div class="navbar-toggle" @click="mobileShow">
						<button type="button" class="navbar-toggler">
							<span class="navbar-toggler-bar bar1"></span>
							<span class="navbar-toggler-bar bar2"></span>
							<span class="navbar-toggler-bar bar3"></span>
						</button>
					</div>
<!--					<router-link tag="a" class="navbar-brand text-secondary" :to="{ name: 'adminDashboard' }">WPO Dashboard-->
<!--					</router-link>-->
				</div>
				<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navigation"
						aria-controls="navigation-index" aria-expanded="false" aria-label="Toggle navigation">
					<span class="navbar-toggler-bar navbar-kebab"></span>
					<span class="navbar-toggler-bar navbar-kebab"></span>
					<span class="navbar-toggler-bar navbar-kebab"></span>
				</button>
        <div class="collapse navbar-collapse justify-content-between" id="navigation">
					<div v-if="user.userType === 'admin' || user.userType === 'manager' || user.userType === 'super-admin'"  class="wrap-autocomplete">
						<multi-select
							id="smart-search"
							v-model="selectedUser"
							label="name"
							track-by="objectId"
							placeholder="Smart search"
							:options="searchList"
							:multiple="false"
							:searchable="true"
							:loading="isLoading || !asyncDone"
							:disabled="!asyncDone"
							:internal-search="false"
							:clear-on-select="true"
							:close-on-select="true"
							:options-limit="300"
							:max-height="600"
							group-values="data"
							group-label="type"
							:group-select="false"
							:show-no-results="true"
              :show-labels="false"
							@search-change="getSearchList">
                <template  slot="option" slot-scope="props">
                    <span v-if="props.option.$groupLabel" v-html="getHtmlForSearch(props.option.$groupLabel)"/>
                    <div v-else class="d-flex justify-content-between">
                      <span>{{ props.option.name }} 	</span>
                      <div>
                        <span @click.stop="goToNuxt(props.option.id)"><i class="fa fa-user"></i></span>
                        <img @click.stop="openUserDetails(props.option.id)" class="autocomplete__icon ml-20" src="../assets/img/goto.svg">
                      </div>


                    </div>
                </template>
                <span slot="noResult">Oops, nothing found.</span>
						</multi-select>
					</div>
          <div>
<!--            <span class="fw-600 busy-factor">Live Busy Factor: </span> <span @click="$router.push('/admin/load-stats')"  style="font-size: 16px !important;font-weight: 600;color: white;background-color: black;border: 2px solid black;font-family: 'Segoe UI', sans-serif; box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);" class="badge badge-pill fs-14 mb-0 make-cursor-pointer">{{getBusyFactor === 0 ? (ticketStats ? calculateBusyCoefficient(ticketStats.last15Min) : 0) : getBusyFactor}}</span>-->
<!--            <span class="mr-20 ml-5">-->
<!--                <i v-if="getTrend" class="text-success fa fa-long-arrow-down fw-400"></i>-->
<!--                <i v-else class="text-danger fa fa-long-arrow-up fw-400"></i>-->
<!--            </span>-->
          </div>
					<ul class="navbar-nav d-flex align-items-center">
            <li @click="$router.push('/admin/load-stats')"  @mouseover="getTitle( true, 'info', `The Busy Factor for the last 15 minutes is ${calculateBusyCoefficient(ticketStats.last15Min)}, compared to ${calculateBusyCoefficient(ticketStats.last30To15Min)} ${ticketStats.last30To15Min ? `(${getTime(ticketStats.last30To15Min.time_from)} - ${getTime(ticketStats.last30To15Min.time_to)})` : ''} in the 15 minutes prior.`)" @mouseleave="getTitle(false)" :id="'info'" class="busy-indicator make-cursor-pointer pt-0 pb-0">
              <span class="busy-label">LIVE BUSY:</span>
              <span class="busy-value">{{calculateBusyCoefficient(ticketStats.last15Min)}}</span>
              <span class="pulse-dot" :style="getTrend ? 'background-color: #1b9c1b;' : 'background-color: #d10000;'"></span>
            </li>
						<li v-if="backendJobLoading && user.userType === 'normal'">
							<div class="loader small_loader" style="width: 40px;height: 40px; margin: 5px 20px 0 0"></div>
						</li>
						<li class="dropdown notification-list topNotificationsList"  v-if="user.userType === 'normal'">
							<a class="nav-link dropdown-toggle waves-effect waves-light" data-toggle="dropdown" href="#" role="button" aria-haspopup="false" aria-expanded="false">
								<i class="fa fa-bell"></i>
								<span v-if="notifications.length" class="badge badge-danger rounded-circle noti-icon-badge">
									{{notifications.length}}
								</span>
							</a>
							<div class="dropdown-menu dropdown-menu-right dropdown-lg">
								<top-notifications />
							</div>
						</li>
						<li class="dropdown notification-list jobLogList" v-if="user.userType === 'super-admin' || user.userType === 'admin' || user.userType === 'manager' || (adminDtls && user.userType === 'normal')">
<!--							<a class="nav-link dropdown-toggle  waves-effect waves-light mr-3" data-toggle="dropdown" href="#" role="button" aria-haspopup="false" aria-expanded="false">-->
<!--								<i class="fa fa-history"></i>-->
<!--							</a>-->
              <button type="button" data-toggle="dropdown" class="nav-link dropdown-toggle waves-effect waves-light btn btn-round btn-outline-primary btn-primary btn-sm pt-0 pb-0 pr-4 pl-4">
                <i class="fa fa-history"></i>
              </button>
							<div class="dropdown-menu dropdown-menu-right dropdown-lg">
								<TopJobLogs/>
							</div>
						</li>

						<li class="nav-item" v-if="userType === 'normal'">
							<router-link tag="button" type="button" :to="{ name: 'openTicket', params: { fromSendReport: true} }" class="nav-link btn btn-outline-danger btn-round btn-danger text-secondary mr-3">
								<i class="fa fa-exclamation-triangle"></i> Send Feedback / Bug Report
							</router-link>
						</li>
						<li class="nav-item" v-if="adminDtls && user.userType === 'normal'">
							<button type="button" class="nav-link btn btn-outline-default btn-round btn-default"
									@click="backToAdmin">
								<i class="fa fa-sign-out"></i> Back to Admin
							</button>
						</li>
						<li class="nav-item" v-if="user.userType !== 'normal' || (adminDtls && user.userType === 'normal')">
							<button id="queueStatus" @mouseover="getTitle(true, 'queueStatus', 'Check Queue Status')" @mouseleave="getTitle(false)" data-toggle="modal" data-target="#queue-modal" type="button" class="nav-link btn btn-round btn-outline-info btn-sm btn-info pt-0 pb-0 pr-4 pl-4">
                <i class="fa fa-hourglass-half"></i>
							</button>
						</li>
            <li class="nav-item" v-if="user.userType !== 'normal' || (adminDtls && user.userType === 'normal')">
              <button @mouseleave="getTitle(false)" @mouseover="getTitle(true, 'manualTask', 'Add Manual Task')" id="manualTask" class="nav-link btn btn-round btn-outline-success btn-sm pt-0 pb-0 pl-4 pr-4 btn-success" data-toggle="modal"  @click="fixModal(null)" data-target="#123">
                <i class="fa fa-plus"></i>
              </button>
            </li>
						<li class="nav-item">
							<button @mouseleave="getTitle(false)" @mouseover="getTitle(true, 'logout', 'Logout')" id="logout" type="button" :disabled="logOutLoading" class="nav-link btn btn-round btn-outline-danger pt-0 btn-sm pb-0 pr-4 pl-4 btn-danger" @click="logout">
								<div v-if="logOutLoading" class="loader small_loader" style="width: 25px;height:25px"></div>
								<span v-else><i class="fa fa-sign-out"></i></span>
							</button>
						</li>
            <li class="nav-item" v-if="testAdmins.includes(user.email)">
              <button class="nav-link btn btn-round btn-outline-success btn-sm pt-0 pb-0 pl-4 pr-4 btn-success" data-toggle="modal"  @click="reload">
                <i class="fa fa-refresh"></i>
              </button>
            </li>
					</ul>
				</div>
			</div>

		</nav>
    <ManualTaskModal :parent-type="parentType" ref="createModal" :changeType="changeParentType" modalId="123"/>
		<!-- Modal -->
		<div class="modal fade" id="queue-modal" tabindex="-1" role="dialog" aria-labelledby="queue-modal" aria-hidden="true">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLongTitle">Queue Status</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="form-group">
							<label for="queueName">Queue</label>
							<input v-model="queueIP" type="text" class="form-control" id="queueName" placeholder="127.0.0.1">
							<small id="emailHelp" class="form-text text-muted">Enter the IP address of server to check the status of server queue.</small>
						</div>
						<div class="row" v-if="queueData">
							<div class="col-md-6">
								Status: <label :class="{'badge badge-success':!queueData.busy, 'badge badge-danger':queueData.busy }">{{ (!queueData.busy) ? 'FREE' : 'BUSY' }}</label>
								<br/><a v-if="queueData.busy" href="javascript:void(0)" @click="freeQueue">Free This Queue</a>
							</div>
							<div class="col-md-6">
								Pending Jobs: <label class="badge-info badge">{{ queueData.jobs.length }}</label>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-primary" :disabled="queueLoading || queueIP === ''" @click="checkStatus">
							<div class="loader mini_loader" v-if="queueLoading"></div>
							<span v-else>Check</span>
						</button>
					</div>
				</div>
			</div>
		</div>
	</section>

</template>

<script>
import logRocket from "../mixins/logRocket";
import {auth, db, functions, messaging} from "@/firebase/init";
import _, {map} from "lodash";
import multiSelect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import Autocomplete from "./Helps/SmartSearchAutocomplete";
import loginAsMixin from "../mixins/loginAsMixin";
import shiftOutAlertMixin from "@/mixins/shiftOutAlertMixin";
// import fetchUsersMixin from "../mixins/fetchUsersMixin";
import md5 from "crypto-js/md5";
import TopNotifications from "./Helps/TopNotifications";
import TopJobLogs from "./Helps/TopJobLogs";
import twoFAMixin from "../mixins/twoFAMixin";
import swal from 'sweetalert2';
import ManualTaskModal from "@/components/Admin/Sales/ManualTaskModal.vue";
import AES from "crypto-js/aes";
import removeUser from "@/mixins/removeUser";
import tippy from "tippy.js";
import 'tippy.js/dist/tippy.css';
import moment from "moment-timezone";

export default {
  name: "TopNav",
  mixins: [loginAsMixin, twoFAMixin, shiftOutAlertMixin, logRocket, removeUser],
  props: {
    createUserPage: {
      required: false
    },
    inCollaborator: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      ticketStats: {},
      listener: null,
      recentlyAccessedUser: [],
      testAdmins: ['wpo-septem-admin@septemsystems.com','rao@bigscoots.com', 'sara@bigscoots.com'],
      navbar_menu_visible: 0,
      adminToken: localStorage.getItem('adminToken'),
      adminDtls: JSON.parse(localStorage.getItem('adminDtls')),
      searchList: [],
      customerListener: null,
      logOutLoading: false,
      queueIP: '',
      queueData: null,
      queueLoading: false,
      isLoading: false,
      selectedUser: null,
      parentType: 'confirmation',
      recentActivityListener: null,
      idleListener: null,
      userSignInListener: null,
      isIdle: false,
      isNowIdle: true,
      currentUserAttendanceId: null,
      eventMouseListenerCallback: null,
    }
  },
  computed: {
    getTrend() {
      const last15MinFactor = this.calculateBusyCoefficient(this.ticketStats.last15Min)
      const last30To15MinFactor = this.calculateBusyCoefficient(this.ticketStats.last30To15Min);
      return last15MinFactor <= last30To15MinFactor;
    },
    getBusyFactor() {
      return this.$store.getters.getBusyFactor;
    },
    asyncDone() {
      return this.$store.getters["async/state"];
    },
    isShowNotificationOnLogIn() {
      return this.$store.getters.isShowNotificationOnLoggedIn;
    },
    isUpNoti() {
      return this.$store.getters.isUpNoti;
    },
    isDownNoti() {
      return this.$store.getters.isDownNoti;
    },
    currentSidebarType() {
      return this.$store.getters['sidebarMini/type']
    },
    userType() {
      return this.$store.getters.getUserType
    },
    user() {
      return this.$store.getters.user;
    },
    UID() {
      return this.$store.getters.getUID;
    },
    notifications() {
      return this.$store.getters['notification/details'];
    },
    notificationListener() {
      return this.$store.getters['notification/getNotificationListener'];
    },
    accountListener() {
      return this.$store.getters['hosting/accountListener'];
    },
    monitorUpListener() {
      return this.$store.getters['monitor/monitorStatusUpListener'];
    },
    monitorDownListener() {
      return this.$store.getters['monitor/monitorStatusDownListener/accountListener'];
    },
    backendJobLoading() {
      return this.$store.getters.backendJobLoading;
    },
    adminNotificationOn() {
      return this.$store.getters.isNotifications;
    },
    getNotificationStatus() {
      return this.user.getNotificationStatus
    }
  },
  components: {
    ManualTaskModal,
    Autocomplete,
    TopNotifications,
    TopJobLogs,
    multiSelect,
    Announcements: () => import(/* webpackChunkName: "userMenu" */ "../components/Helps/Announcements.vue"),
  },
  watch: {
    async selectedUser(val) {
      if (val && val.id && this.UID !== val.id) {
        await this.saveUserToDB(val);
        this.selectUser(val)
      }
    }
  },
  methods: {
    getTime(time) {
      return moment.tz(time, 'America/Chicago').tz('America/New_York').format("HH:mm");
    },
    calculateBusyCoefficient(obj) {
      if(!obj) {
        obj = {
          availableCount: 1,
          total_tickets_handled: 0,
          total_responses: 0
        }
      }
      let availableCount = obj ? obj.availableCount : 1
      const factor = (((obj.total_tickets_handled+obj.total_responses)/Number(availableCount)).toFixed(2))
      return isNaN(Number(factor)) ? 0 : factor
    },
    async getCurrentTicketLoad(){
      this.ticketStats = {}
      this.listener = await db.collection('dashboardStats').where('type', '==','ticket').where('date', '==', moment().tz('America/New_York').format('YYYY-MM-DD')).onSnapshot(querySnapshot => {
        querySnapshot.docChanges().forEach(changeDoc => {
          if (changeDoc.type === 'added'){
            console.log('addin new', 418)
            this.ticketStats = ({id: changeDoc.doc.id, ...changeDoc.doc.data()})
          }
          if(changeDoc.type === 'modified') {
            console.log('modified')
            this.ticketStats = ({id: changeDoc.doc.id, ...changeDoc.doc.data()})
          }
          if(changeDoc.type === 'removed') {
            this.ticketStats = {}
          }
        });
      });
    },
    getTitle(flag, id, title) {
      if(!flag) {
        return true
      }
      tippy(`#${id}`, {
        animation: 'fade',
        arrow: true,
        content: title,
        theme: 'gradient', // Customize the theme in your CSS if needed
        placement: 'top'
      });
    },
    goToNuxt(docId) {
    if (docId) {
      window.open(`https://wpo.bigscoots.com/user/dashboard?id=${docId}`, 'WPO-Bigscoots');
    }
  },
    openUserDetails(docId) {
    if (docId) {
      this.initateLogRocket()
      // this.$router.push({ name: 'editUser', params: { docID } })
      this.selectedUser = null
      window.open(`/admin/edit-user/${docId}`);
    }
  },
    async getUserSignInStatus() {
    const ref = await db.collection('attendance').where('status', '==', true).where('userUid', '==', this.user.uid);
    this.userSignInListener = ref.onSnapshot(async querySnapshot => {
      querySnapshot.docChanges().forEach(changeDoc => {
        if (changeDoc.type === 'removed') {
          console.log('removed method, status false');

          this.isIdle = false;
          this.currentUserAttendanceId = null;

          this.$store.dispatch('setSignedInOrOnBreakStatus', false);
          return;
        }

        // ✅ Handle added + modified
        const doc = changeDoc.doc;
        const data = doc.data();

        // 🛡️ safe access
        const breaks = Array.isArray(data.breaks) ? data.breaks : [];
        const lastBreak = breaks.length > 0 ? breaks[breaks.length - 1] : null;

        this.currentUserAttendanceId = doc.id;

        // 🔍 Logic
        if (lastBreak && lastBreak.endTime) {
          console.log(`${changeDoc.type} → break out`);

          this.isIdle = true;
          this.$store.dispatch('setSignedInOrOnBreakStatus', false);

        } else if (lastBreak && !lastBreak.endTime) {
          console.log(`${changeDoc.type} → break in`);

          this.isIdle = false;
          this.$store.dispatch('setSignedInOrOnBreakStatus', true);

        } else {
          console.log(`${changeDoc.type} → signed in`);

          this.isIdle = true;
          this.$store.dispatch('setSignedInOrOnBreakStatus', false);
        }

      });
    });
  },
    encryptIndex(index) {
    return AES.encrypt(index, this.aesSecret).toString()
  },
    onMessageListener() {
    if (this.getNotificationStatus) {
      messaging.onMessage((data) => {
        console.log('payload received', data)
        if (data.data.title !== 'Recent comment') {
          const message = `<div class="d-flex align-items-center">
                <div class="mr-5"> <i class="fa fa-info-circle fa-2x" aria-hidden="true"></i></div>
                <div class="ml-5">
                <div>
                <span>New reply has been added to ticket #${data.data.ticketID}. Click <strong><a target="_blank" href="https://portal.bigscoots.com/admin/?cmd=tickets&action=view&brc=MTA&num=${data.data.ticketID}" style="color: darkred">here</a></strong> to view ticket.</span>
                </div> </div> </div>`
          this.showToast({message, duration: 0}, true, 'danger')
        }
      })
    }
  },
    async startListener() {
    try {
      const date = new Date().toISOString()
      let query;
      const userRef = await db.collection('users').doc(this.user.uid).get()
      const {getNotificationStatus} = userRef.data()
      query = db.collection('recentActivity').where('createdAt', '>=', date); // need to add admin.uid !== this.admin.uid
      this.recentActivityListener = query.onSnapshot(querySnapshot => {
        querySnapshot.docChanges().forEach(changeDoc => {
          if (changeDoc.type === 'added') {
            const value = changeDoc.doc.data()
            const {actionType, admin, message} = value; // value.admin.uid === this.user.uid
            if (this.user.email !== value.admin.email && getNotificationStatus) {
              this.modelUp(actionType, admin, message);
            }
          }
        })
      });
    } catch (e) {
      console.log(e.toString())
    }
  },
    async modelUp(topMessage, admin, message) {
    const trimEmail = await md5(admin.email.trim().toLowerCase()).toString();
    // <h6 class="mb-10"> ${topMessclassName < /h6>
    const messageTemplate = `<div class="d-flex align-items-center">
            <div><img class="rounded-circle" width="95%" src="https://www.gravatar.com/avatar/${trimEmail}?s=50"></div>
            <div class="pl-5"><div><span class="text-center text-capitalize font-weight-bold ">${admin.name}</span></div> <span>${message}</span></div>`
    this.showToast({message: messageTemplate})
  },
    async saveUserToDB(val) {
    if (this.recentlyAccessedUser.length > 0) {
      if (this.recentlyAccessedUser.length >= 10) {
        this.recentlyAccessedUser.splice(9, 1);
      }
      // if already exists in array
      if (this.recentlyAccessedUser.some(el => el.id === val.id)) {
        this.recentlyAccessedUser = this.recentlyAccessedUser.filter(el => el.id !== val.id);
      }
      this.recentlyAccessedUser.unshift(val);
    } else {
      this.recentlyAccessedUser = [];
      this.recentlyAccessedUser.push(val);
    }
    await db.collection('users').doc(this.UID).update({recentlyAccessedUser: this.recentlyAccessedUser});
  },
    async getRecentlyAccessedUser() {
    if (this.UID && this.UID) {
      const adminData = await db.collection('users').doc(this.UID).get();
      console.log('admin data', adminData.data())
      this.recentlyAccessedUser = adminData.data().recentlyAccessedUser ? adminData.data().recentlyAccessedUser : [];
      console.log('users', this.recentlyAccessedUser)
      this.searchList = [
        {
          type: 'Recently Access Users',
          icon: '<i class="fa fa-user"></i>',
          data: this.recentlyAccessedUser
        }
      ]
    }
  },
    changeParentType(value) {
    console.log(value)
    if (value === 'true') {
      this.parentType = 'sales'
    } else {
      this.parentType = 'support'
    }
  },
    fixModal(link = null) {
    this.parentType = 'confirmation'
    this.$refs.createModal.fixModal(link)
  },
    async snapshotForReload() {
    try {
      console.log('inside snapshot for reload')
      const query = await db.collection('permissions').doc('reload');
      await query.onSnapshot(async (docUpdate) => {
        console.log(docUpdate)
        const {value} = docUpdate.data()
        if (value) {
          console.log('Updating Data...');
          window.location.reload(true)
        }
      });
      await db.collection('permissions').doc('reload').update({value: false})
    } catch (e) {
      console.log(e.toString())
    }
  },
    async reload() {
    try {
      const query = await db.collection('permissions').doc('reload').get();
      if (query.exists) {
        console.log('value exists')
        await db.collection('permissions').doc('reload').update({value: true})
      } else {
        await db.collection('permissions').doc('reload').set({value: true})
      }
      swal('Success', 'You have successfully reloaded', 'success')
    } catch (e) {
      console.log(e.toString())
      swal('Error', 'Something went worng', 'error')
    }
  },
    async freeQueue() {
    this.queueLoading = true;
    if (this.queueIP) {
      await db.collection('BSQueue').doc(this.queueIP).update({
        busy: false
      });
      this.queueLoading = false;
      $('#queue-modal').modal('hide');
      swal('Un-Locked!', 'Queue: ' + this.queueIP + ' is free and start processing the jobs now!', 'success');
    }
  },
    async checkStatus() {
    this.queueLoading = true;
    const queueRef = await db.collection('BSQueue').doc(this.queueIP).get();
    if (!queueRef.exists) {
      swal('Error!', 'Queue Not Found!', 'error');
    } else {
      this.queueData = queueRef.data();
    }
    this.queueLoading = false;
  },
    getHtmlForSearch(label) {
    switch (label) {
      case 'Customers':
        return '<i class="fa fa-users mr-5" /> <span>Customers</span>'
      case 'Collaborators':
        return '<i class="fa fa-users mr-5" /> <span>Collaborators</span>'
      case 'Accounts':
        return '<i class="fa fa-cloud mr-5" /> <span>Accounts</span>'
      case 'Domains':
        return '<i class="fa fa-globe mr-5" /> <span>Domains</span>'
      case 'Recently Access Users':
        return '<i class="fa fa-user mr-5" /> <span>Recently Accessed Users</span>'
    }
  },
    async getSearchList(query) {
    if (query.length > 0) {
      this.searchList = []
      this.isLoading = true;
      let customers = [];
      let collaborators = [];
      let accounts = [];
      let domains = [];
      const searchRef = await this.$http.post("algolia/search", {
        grant_type: "token",
        query
      });

      let customersObjects = _.groupBy(searchRef.data, function (item) {
        // console.log(item)
        return item.uid
      })
      _.forEach(customersObjects, function (arrr, key) {
        if (arrr[0].customerID === '-1') {
          collaborators.push({
            id: key,
            name: `${arrr[0].firstName} ${arrr[0].lastName} ${arrr[0].email}`,
            fullName: `${arrr[0].firstName} ${arrr[0].lastName}`,
            type: 'collaborator'
          })
        } else {
          customers.push({
            id: key,
            name: `#${arrr[0].customerID} ${arrr[0].firstName} ${arrr[0].lastName} ${arrr[0].email}`,
            fullName: `${arrr[0].firstName} ${arrr[0].lastName}`,
            type: 'customer'
          })
        }
      })
      map(searchRef.data, (item) => {
        if (item.domain) {
          let accountDetail = {
            id: item.uid,
            name: `${item.domain} u: ${item.firstName} ${item.lastName} ip: ${item.serverIP}`,
            type: 'accountDetail'
          };
          let domain = {
            id: item.uid,
            name: `${item.domain}`,
            type: 'domain'
          };
          accounts.push(accountDetail)
          domains.push(domain)
        }
      });
      this.searchList = [
        {
          type: 'Customers',
          icon: '<i class="fa fa-user"></i>',
          data: customers
        },
        {
          type: 'Collaborators',
          icon: '<i class="fa fa-user"></i>',
          data: collaborators
        },
        {
          type: 'Accounts',
          icon: '<i class="fa fa-cloud"></i>',
          data: accounts
        },
        {
          type: 'Domains',
          icon: '<i class="fa fa-globe"></i>',
          data: domains
        }
      ];
      this.isLoading = false;

    } else {
      this.searchList = [
        {
          type: 'Recently Access Users',
          icon: '<i class="fa fa-user"></i>',
          data: this.recentlyAccessedUser
        }
      ];
    }
  },
    async removeFcmToken() {
      try {
        console.log(this.user.uid);
        const token = await messaging.getToken()
        const ref = await db.collection('users').doc(this.user.uid).get();
        let {fcmToken} = ref.data()
        if(fcmToken){
          if (Array.isArray(fcmToken)) {
            if (fcmToken.includes(token)) {
              const indexToRemove = fcmToken.indexOf(token);
              if (indexToRemove !== -1) {
                fcmToken.splice(indexToRemove, 1);
              }
            }
          } else if (fcmToken === token) {
            fcmToken = [];
          }
        }
        else{
          fcmToken= []
        }
        console.log('tokens', fcmToken)
        await db.collection('users').doc(this.user.uid).update({
          fcmToken: [...fcmToken]
        });
        console.log('updated collection');
        // dismiss all toast i.e unacknowledged toast
        this.$toast.clear();
      } catch (e) {
        console.log(e)
      }
  },
    async logout() {
    try {
      await this.removeFcmToken()
    } catch (e) {
      console.log('Error occurred in removing the token ')
    }
    this.logOutLoading = true;
    await this.updateTwoFAVerified(false);
    this.$store.commit('updateShowNotificationOnLogIn', true);
    if (this.customerListener) {
      console.log('Detaching Listener');
      this.customerListener();
    }
    if (this.notificationListener) {
      console.log('detach notification listener');
      this.notificationListener();
    }
    if (this.accountListener) {
      console.log('detach account listener');
      this.accountListener();
    }
    if(this.monitorUpListener){
      this.monitorUpListener();
    }
    if (this.monitorDownListener){
      this.monitorDownListener();
    }
      console.log('Closing socket')
    if (this.userType === 'admin' || this.userType === 'super-admin' || this.adminDtls) {
      console.log('Detaching Admin Listeners...');
      this.$store.dispatch('notification/resetAdminListens');
      this.$store.dispatch('tasks/resetActiveSalesListener');
      this.$store.dispatch('tasks/resetActiveSupportListener');
    }

    auth.signOut().then(() => {
      this.$cookie.delete('login-session');
      localStorage.removeItem("userDtls");
      localStorage.removeItem('adminToken');
      localStorage.removeItem('adminDtls');
      localStorage.removeItem('accounts');
      localStorage.removeItem('customers');
      window.location = '/'
      // this.$router.push({name: "login"});
    });
  },
    backToAdmin() {
    this.$store.commit('updateShowNotificationOnLogIn', true);
    if (this.notificationListener) {
      console.log('detach notification listener');
      this.notificationListener();
    }
    if (this.accountListener) {
      console.log('detach account listener');
      this.accountListener();
    }
    let backUser = JSON.parse(localStorage.getItem('userDtls'));
    console.log(backUser);
    console.log(backUser.userType);
    if (backUser.userType === 'admin' || backUser.userType === 'super-admin' || backUser.userType === 'manager') {
      this.$router.push({name: 'adminDashboard'});
      return;
    }
    localStorage.setItem('userDtls', JSON.stringify(this.adminDtls));
    localStorage.removeItem('adminDtls');
    if (localStorage.getItem('backUrl') && localStorage.getItem('backUrl') === 'migration') {
      this.$router.push({name: 'migration-tasks', params: {docID: backUser.uid}})
    } else {
      this.$router.push({name: 'editUser', params: {docID: backUser.uid}})
    }
    // auth.signOut().then(() => {
    // 	localStorage.removeItem("userDtls");
    // 	localStorage.setItem('loginAsUser', localStorage.getItem('adminToken'));
    // 	this.$router.push({name: "adminDashboard"});
    // });
  },
    changeSidebarType() {
    this.$store.dispatch('sidebarMini/update', {type: !this.currentSidebarType})
  },
    mobileShow() {
    /* eslint-disable */
    let $toggle = $(this);
    if (this.navbar_menu_visible == 1) {
      $("html").removeClass("nav-open");
      this.navbar_menu_visible = 0;
      setTimeout(function () {
        $toggle.removeClass("toggled");
        $("#bodyClick").remove();
      }, 550);
    } else {
      setTimeout(function () {
        $toggle.addClass("toggled");
      }, 580);

      let div = '<div id="bodyClick"></div>';
      $(div)
          .appendTo("body")
          .click(function () {
            $("html").removeClass("nav-open");
            this.navbar_menu_visible = 0;
            setTimeout(function () {
              $toggle.removeClass("toggled");
              $("#bodyClick").remove();
            }, 550);
          });

      $("html").addClass("nav-open");
      this.navbar_menu_visible = 1;
    }
    /* eslint-enable */
  },
    selectUser(data) {
      this.initateLogRocket()
      const id = data.id
      this.$router.push({name: 'editUser', params: {docID: id.split('_dup')[0]}})
      this.selectedUser = null
      // this.searchList = []
    },
  },
  async created() {
    if (this.userType === 'normal' && !this.adminDtls) {
      const twoFAVerified = await this.getTwoFAVerified();
      if (!twoFAVerified) {
        this.logout();
      }
    }
    if (this.userType === 'admin' || this.userType === 'manager' || this.userType === 'super-admin') {
      const twoFAVerified = await this.getTwoFAVerified();
      if (!twoFAVerified) {
        this.logout();
      }
    }
  },
  mounted() {
    $(function () {
      $('[data-toggle="tooltip"]').tooltip()
    })
    this.forcedLogoutSnapShot()
    this.getUserSignInStatus()
    this.onMessageListener()
    this.startListener();
    this.snapshotForReload()
    this.getCurrentTicketLoad()
    $('#queue-modal').on('hidden.bs.modal', () => {
      this.queueIP = '';
      this.queueData = null;
    })
    if (this.isShowNotificationOnLogIn && this.userType === 'normal') {
      console.log('Showing notifications...');
      this.$store.dispatch('notification/resetNotifications');
      this.$store.dispatch('notification/fetchNotifications');
      console.log('Creating snapshot on accounts');
      this.$store.dispatch('hosting/createRealTimeSnapShotOnUserAccount');
      console.log('Fetching Last 4 Notifications');
      this.$store.dispatch('notification/fetchLastFourNotifications');
    } else if (this.isUpNoti && this.isDownNoti && this.userType !== 'normal' && this.adminNotificationOn) {
      console.log('Start for Admin Notifications....');
      this.$store.dispatch('notification/adminNotifications');
    }

			if(this.userType === 'admin' || this.userType === 'manager' || this.userType === 'super-admin') {
				console.log('Start for Admin job logs Notification....');
				this.$store.dispatch('notification/fetchJoblogs');
				this.$store.dispatch('tasks/fetchActiveSalesTasks');
				this.$store.dispatch('tasks/fetchActiveSupportTasks');
				this.$store.dispatch('tasks/fetchActiveMigrationsTasks');
			}
      this.getRecentlyAccessedUser();

      /* eslint-disable */
			const paperDashboard2 = {
				misc: {
					sidebar_mini_active: false
				},
				initMinimizeSidebar: function () {
					$("#minimizeSidebar").click(function () {
						let $btn = $(this);
						if (paperDashboard2.misc.sidebar_mini_active == true) {
							$("body").removeClass("sidebar-mini");
							paperDashboard2.misc.sidebar_mini_active = false;
						} else {
							$("body").addClass("sidebar-mini");
							paperDashboard2.misc.sidebar_mini_active = true;
						}

						// we simulate the window Resize so the charts will get updated in realtime.
						var simulateWindowResize = setInterval(function () {
							window.dispatchEvent(new Event("resize"));
						}, 180);

						// we stop the simulation of Window Resize after the animations are completed
						setTimeout(function () {
							clearInterval(simulateWindowResize);
						}, 1000);
					});
				}
			};
			$('.dropdown-toggle').on('click', function (e) {
				$(this).next().toggle();
			});
			$('.dropdown-menu.keep-open').on('click', function (e) {
				e.stopPropagation();
			});
			paperDashboard2.initMinimizeSidebar();
			const topNotificationSelector = $(".topNotificationsList");
			const jobListSelector = $(".jobLogList");
			topNotificationSelector.on('hidden.bs.dropdown',  () => {
				const markAsReadAllNotification = functions.httpsCallable(
						"markAsReadAllNotification"
				);
				markAsReadAllNotification({UID: this.UID})
						.then(() => {
							this.$store.dispatch('notification/resetNotifications');
						})
						.catch(err => {
							console.log(err.message);
						})
			})
			$(document).click(function () {
				$('.notification-list .dropdown-menu').attr('style', 'display:none');
			})
			jobListSelector.on('show.bs.dropdown',  () => {
				$(".topNotificationsList .dropdown-menu").attr('style', 'display:none');
			});
			topNotificationSelector.on('show.bs.dropdown',  () => {
				$(".jobLogList .dropdown-menu").attr('style', 'display:none');
			});
			/* eslint-enable */
		},
    beforeDestroy() {
    if (this.recentActivityListener) {
      this.recentActivityListener()
    }
    if(this.userSignInListener){
      this.userSignInListener()
    } if(this.listener){
      this.listener()
    }
  },
	};
</script>


<style>
  .multiselect__option--highlight{
    background: #5a7cfd !important;
  }
  .multiselect__option--highlight:after{
    background: #5a7cfd !important;
  }
  .multiselect__tag{
    background: #5a7cfd !important;
  }
  .multiselect__tag-icon:hover{
    background: red !important;
  }
  .multiselect__tag-icon:after {
    color: white !important;
  }
</style>
<style lang="scss">
	.navbar {
		.navbar-nav {
			.nav-link {
				&.btn {
					padding: 0 22px;
				}
			}
		}
	}
	.fa-history{
		//font-size: 21px !important;
		//vertical-align: middle !important;
		//color: #007bff !important;
	}
	.wrap-autocomplete {
		margin-right: 50px;
		width: 50%;
	}

	.bg-white-always {
		background: white !important;
	}
	.main-panel > .content{
		margin-top: 0 !important;
	}
  .v-toast__item.v-toast__item--success .v-toast__icon{
  display: none
  }
  .v-toast__item.v-toast__item--error .v-toast__icon{
  display: none
  }
 .v-toast__item--success{
   height: 90px;
   width: 340px;
   background-color: #DEFBE6 !important;
   color: darkgreen !important;
   border-left: darkgreen ;
   border-left-style: solid;
 }
  .v-toast__item--error{
    height: 90px;
    width: 340px;
    background-color: #FDDDDD !important;
    color: darkred !important;
    border-left: darkred ;
    border-left-style: solid;
  }
  .badge-bubble{
    display: inline-block;
    padding: 1px 8px 1px 8px;
    font-size: 14px;
    font-weight: 600;
    color: #2d7a4d;
    background-color: #e2f5e9;
    border: 2px solid #a0dfb6;
    font-family: 'Segoe UI', sans-serif;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }
  .busy-factor {
    font-family: 'Segoe UI', sans-serif;
    font-weight: 600;
    font-size: 18px;
    color: #1e1e1e;
  }
  .arrow {
    font-size: 20px;
    margin: 0 5px;
  }

  .arrow.up {
    color: #6FCF97; /* soft green */
  }

  .arrow.down {
    color: #EB815C; /* soft orange */
  }
  .busy-indicator {
    height: 35px;
    display: flex;
    align-items: center;
    padding: 2px 12px;
    border-radius: 999px;
    border: 1px solid #ccc;
    background-color: #f5f5f5;
    font-size: 13px;
    font-weight: 600;
    margin-right: 12px;
  }

  .busy-label {
    margin-right: 5px;
    color: #333;
  }

  .busy-value {
    margin-right: 8px;
    color: #000;
  }

  .pulse-dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
     /* green for down, change to #d10000 for up */
    position: relative;
  }

  .pulse-dot::after {
    content: "";
    position: absolute;
    top: 0; left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: inherit;
    animation: pulse 1.2s ease-out infinite;
  }

  @keyframes pulse {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    100% {
      transform: scale(2);
      opacity: 0;
    }
  }
  .dropdown-toggle::after{
    display: none;
  }
</style>
